import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "./communitiesStories.scss";
import { Link } from "gatsby";

const CommunitiesStories = (props: ReferenciaContenido) => {

    return (
        <div className="m-cmnd-video-card">
            <div className="m-cmnd-video-card__left">
                <div className="m-cmnd-video-card__left__video-container">
                    <video controls
                        poster="">
                        <source src={props.video}></source>
                        Su navegador no soporta Video HTML.
                    </video>
                </div>
            </div>
            <div className="m-cmnd-video-card__right">
                <div className="m-title-section">
                    <h2>{props.tituloGeneral}</h2>
                    
                    <br/>
                    <br/>
                    <br/>

                    <span>
                        {props.etiquetasArticulo[0]}
                    </span>

                    <br/>
                    <br/>
                    <br/>

                    <div className="m-cmnd-video-card__right__description">
                        {props.descripcion.json.content[0].content[0].value}
                    </div>

                    <br/>
                    <br/>
                    <br/>
                    <br/>

                    <div className="banner-text__buttons__item">
                        <Link
                            target="_self"
                            rel="next"
                            className="a-button a-button__magenta"
                            to={props.redireccionBoton}
                        >
                            {props.tituloBoton}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunitiesStories;
